"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FhtPondCount_exports = {};
__export(FhtPondCount_exports, {
  FhtPondCount: () => FhtPondCount
});
module.exports = __toCommonJS(FhtPondCount_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const FhtPondCount = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("FhtPondCount"),
  title: "Urban Pond Count",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("FhtPondCount"),
      title: "Urban Pond Count",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("FhtPondCount"),
        attribution: []
      }),
      defaultAttribute: "presence",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey Details",
          attributes: [
            (0, import_topo_map.timestampAttr)({
              label: "Date/Time",
              attributeId: "timestamp",
              buckets: "auto"
            }),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Existing Pond",
          attributes: [
            (0, import_topo_map.stringAttr)({
              label: "Square Number",
              attributeId: "map_squareNumber",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              label: "Square Name",
              attributeId: "map_squareName",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              label: "Pond Number",
              attributeId: "map_pondNumber",
              buckets: "auto"
            }),
            (0, import_topo_map.enumAttr)({
              label: "Pond Area",
              attributeId: "map_size",
              enum: import_inventory_enums.FhtPondCountSizeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Presence or Absence",
          attributes: [
            (0, import_topo_map.enumAttr)({
              label: "Presence or Absence",
              attributeId: "presence",
              enum: import_inventory_enums.FhtPondCountPresenceEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Newly Found Ponds",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              label: "Why Newly Found?",
              attributeId: "newPond_whyNew",
              buckets: "auto"
            }),
            ...import_inventory_enums.FhtPondCountWhyCreatedEnum.entries.map(
              ({ value, label }) => (0, import_topo_map.booleanAttr)({
                label,
                attributeId: `newPond_whyCreated_${value}`,
                buckets: "auto"
              })
            ),
            (0, import_topo_map.enumAttr)({
              label: "Why Previously Missed?",
              attributeId: "newPond_whyMissed",
              enum: import_inventory_enums.FhtPondCountWhyMissedEnum
            }),
            (0, import_topo_map.enumAttr)({
              label: "Pond Area",
              attributeId: "newPond_size",
              enum: import_inventory_enums.FhtPondCountSizeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Existing Ponds",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              label: "Existing Area Correct?",
              attributeId: "existingPond_sizeCorrect",
              buckets: "auto"
            }),
            (0, import_topo_map.enumAttr)({
              label: "Updated Area",
              attributeId: "existingPond_updatedSize",
              enum: import_inventory_enums.FhtPondCountSizeEnum
            }),
            (0, import_topo_map.enumAttr)({
              label: "Why Area Changed",
              attributeId: "existingPond_whySizeChanged",
              enum: import_inventory_enums.FhtPondCountWhySizeChangedEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Absent Ponds",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              label: "Misidentified?",
              attributeId: "absentPond_misidentified",
              buckets: "auto"
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Lost or Destroyed?",
              attributeId: "absentPond_lostOrDestroyed",
              buckets: "auto"
            }),
            ...import_inventory_enums.FhtPondCountWhyLostOrDestroyedEnum.entries.map(
              ({ value, label }) => (0, import_topo_map.booleanAttr)({
                label,
                attributeId: `absentPond_whyLostOrDestroyed_${value}`,
                buckets: "auto"
              })
            )
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FhtPondCount
});
//# sourceMappingURL=FhtPondCount.js.map
